import React from "react";
import { Form } from "react-bootstrap";

export default function FileUploadField({
  name,
  value,
  onChange,
  onDelete,
  error,
  isLoading,
  placeholder,
  deleteIcon,
  label = "",
  accept = "image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  isDisabled = false,
  onPreview = null,
}) {
  // Function to extract the clean filename from a URL, ignoring query parameters
  const getCleanFileNameAndExtension = (url) => {
    try {
      const urlObject = new URL(url);
      const pathname = urlObject.pathname; // e.g., /path/to/my-image.jpg
      const parts = pathname.split("/");
      const filenameWithExtension = parts[parts.length - 1]; // e.g., my-image.jpg
      return filenameWithExtension;
    } catch (e) {
      // If not a valid URL, treat the whole 'url' as the filename
      return url;
    }
  };

  // Get the clean filename (e.g., "my-image.jpg")
  const cleanFileName = value ? getCleanFileNameAndExtension(value) : "";

  // Determine if the *clean filename* indicates an image
  const isImageUrl = cleanFileName.match(/\.(jpeg|jpg|gif|png|webp|avif)$/i); // Added more common image formats

  console.log("FileUploadField Debug Info:");
  console.log("  Value (raw prop):", value);
  console.log("  Clean Filename:", cleanFileName);
  console.log("  Is Image URL (based on clean filename):", isImageUrl);

  return (
    <Form.Group className="mb-3">
      {label && <Form.Label>{label}</Form.Label>}
      <div className="pt-2">
        {!value && !isDisabled ? (
          <div>
            <label>
              {isLoading ? (
                <div className="Group">
                  <span className="spinner-border spinner-border-lg"></span>
                </div>
              ) : (
                <img
                  style={{ height: "190px" }}
                  src={placeholder}
                  alt="placeholder"
                />
              )}
              <Form.Control
                type="file"
                className="d-none"
                name={name}
                onChange={onChange}
                accept={accept}
                disabled={isDisabled}
              />
            </label>
            {error && <p className="p-error">{error}</p>}
          </div>
        ) : (
          <div className="img-preview" style={{ position: "relative" }}>
            <div
              onClick={
                onPreview
                  ? () => onPreview({ url: value, name: cleanFileName })
                  : null
              }
              style={{
                cursor: onPreview ? "pointer" : "default",
                position: "relative",
              }}
              title={onPreview ? "Click to preview" : ""}
            >
              {isImageUrl ? (
                // Display image preview using the original 'value' (full signed URL)
                <img src={value} alt="Preview" style={{ maxHeight: "190px" }} />
              ) : (
                // Display file name for non-image files, or if isImageUrl is false
                <div
                  className="file-name-display"
                  style={{
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    backgroundColor: "#f8f9fa",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i
                    className="bi bi-file-earmark-text"
                    style={{ fontSize: "40px", color: "#6c757d" }}
                  ></i>
                  <p
                    className="mt-2 mb-0"
                    style={{
                      fontSize: "12px",
                      color: "#6c757d",
                      textAlign: "center",
                    }}
                  >
                    {cleanFileName}
                  </p>
                  {onPreview && (
                    <small className="text-primary mt-1">
                      <i className="bi bi-eye"></i> Click to preview
                    </small>
                  )}
                </div>
              )}
            </div>

            {!isDisabled && onDelete && (
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
                className="clear"
                src={deleteIcon}
                alt="clear-preview"
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  zIndex: 10,
                }}
              />
            )}
          </div>
        )}
      </div>
      {error && <Form.Text className="text-danger">{error}</Form.Text>}
    </Form.Group>
  );
}
